document.addEventListener("teeinblue-event-component-injected", function () {
  //   const sizeOption = document.querySelector(".tee-option--size");
  //   if (sizeOption) {
  //     const note = document.createElement("div");
  //     note.style.marginTop = "10px";
  //     note.style.fontSize = "14px";
  //     note.style.color = "#555";
  //     note.innerHTML = `Hai bisogno di un quantità diversa da quelle che trovi qui? Scrivici a <a href="mailto:martina@americanunclegifts.it" style="color: #555; text-decoration: underline;">martina@americanunclegifts.it</a>`;

  //     sizeOption.appendChild(note);
  //   }
  // });

  const elementToMove = document.querySelector(".tee-block.tee-product-price");
  const insertAfterElement = document.querySelector(".product-title-desktop");
  if (elementToMove && insertAfterElement) {
    insertAfterElement.after(elementToMove);
    elementToMove.style.marginTop = "-10px";
  }
});
